import React from 'react';
import { useAuth } from '@domain/auth/auth.hook';
import { useFormData } from '@domain/hooks/use.form.data';
import { RequestDialog } from '@components/dialog/request.dialog';
import { DescText } from '@styles/common';
import { ToggleDialogProps } from '@screens/players/player.actions/toggles/toggle.dialog.props';

const ActionLoggingDialog = ({ player, requestChange, ...rest }: ToggleDialogProps) => {
  const { authorizedServices } = useAuth();
  const { blocked } = player.toggles;

  const formData = useFormData(player.pid, function requestActionLogging(data, cancelToken) {
    return authorizedServices.patch(`/admin/toggles/action-logging/`, {
      cancelToken,
      pid: player.pid,
      block: blocked,
    });
  });

  const { actionLogging } = player.toggles;

  const props = {
    icon: 'receipt_long',
    title: actionLogging ? 'Disable action logging' : 'Enable action logging',
    successMsg: `Action logging ${actionLogging ? 'disabled' : 'enabled'} successfully!`,
    onSuccess: requestChange,
  };

  return (
    <RequestDialog formData={formData} {...props} {...rest}>
      <DescText>
        Are you sure you want to <strong>{actionLogging ? 'disable' : 'enable'}</strong> action logging for this player?
      </DescText>
    </RequestDialog>
  );
};

export default ActionLoggingDialog;
